export const MAX_GALLERY_ITEMS = 10;
